import {Component, Input, OnInit} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    selector: "fui-page-header-heading",
    templateUrl: "./page-header-heading.component.html",
    styleUrls: ["./page-header-heading.component.scss"],
    standalone: false
})
export class FUIPageHeaderHeadingComponent implements OnInit {
    @Input() title: string;
    @Input() description: string;

    constructor() {

    }

    ngOnInit() {

    }

    /**
     *
     * @returns {boolean}
     */
    hasDescription(): boolean {
        if (this.description) {
            if (this.description != " ") {
                return true;
            }
        }

        return false;
    }

    /**
     *
     * @returns {boolean}
     */
    hasTitle(): boolean {
        if (this.title) {
            if (this.title != " ") {
                return true;
            }
        }

        return false;
    }
}
